import React from 'react';
import ModernChatInterface from './ModernChatInterface';

/**
 * Canonical "Ask Kai" tab content — same UI in every RCM service (matches Denial Management).
 *
 * @param {string} serviceKey - key in kaiChatConfig (e.g. 'denial_management')
 * @param {object} [copilotService] - optional API client override (Denial Management full agent)
 * @param {object} [configOverride] - optional welcome message / model label overrides
 * @param {string} [className] - optional wrapper classes
 */
const KaiAskPanel = ({ serviceKey, copilotService, configOverride, className = '' }) => (
  <div className={`kai-ask-panel ${className}`.trim()}>
    <ModernChatInterface
      serviceKey={serviceKey}
      copilotService={copilotService}
      configOverride={configOverride}
    />
  </div>
);

export default KaiAskPanel;
